import { IBoardSounds } from '../types';
import capture from './capture.mp3?url';
import move from './move.mp3?url';

export default {
  move,
  capture,
} satisfies Record<IBoardSounds, string>;
